<template>
  <v-card
    v-bind="$attrs"
    :class="classes"
    :style="{
      borderRadius: '8px',
      background: background,
      color: cardDashboard ? 'white' : 'black',
    }"
  >
    <div
      class="d-flex flex-wrap grow"
    >
      <v-avatar
        v-if="avatar"
        size="128"
        class="mx-auto v-card--material__avatar elevation-5"
        color="grey"
      >
        <v-img :src="avatar" />
      </v-avatar>

      <v-sheet
        v-if="!cardDashboard"
        :class="{
          'pa-5': !$slots.image,
        }"
        :color="color"
        :max-height="icon ? 90 : undefined"
        :width="icon ? 'auto' : '100%'"
        elevation="5"
        class="text-start v-card--material__heading"
        dark
        :style="icon ? 'height: 64px; min-width: 48px; width: 64px; border-radius: 13px;': 'border-radius: 13px;'"
      >
        <slot
          v-if="$slots.heading"
          name="heading"
        />

        <slot
          v-else-if="$slots.image"
          name="image"
        />

        <div
          v-else-if="title && !icon"
          class="mb-0 text-h4 text-typo font-weight-bold"
          v-text="title"
        />

        <v-icon
          v-else-if="icon"
          size="24"
          v-text="icon"
        />

        <div
          v-if="text"
          class="headline font-weight-thin"
          v-text="text"
        />
      </v-sheet>
      <v-sheet
        v-if="cardDashboard"
        height="64"
        width="64"
        elevation="5"
        class="icone-center my-auto ml-n7"
        style="border-radius: 13px;"
      >
        <v-icon
          size="24"
          :color="color"
        >
          {{ icon }}
        </v-icon>
      </v-sheet>

      <div
        v-if="$slots['after-heading']"
        class="ml-3"
      >
        <slot name="after-heading" />
      </div>

      <div
        v-else-if="icon && title"
        class="ml-3"
      >
        <div
          class="display-2 pt-2 font-weight-bold "
          v-text="title"
        />
      </div>

      <v-card
        v-if="$slots.grafico"
        class="v-card--material__heading mb-n6"
        :width="'100%'"
        elevation="0"
        style="overflow-x: auto; overflow-y: hidden;"
      >
        <slot name="grafico" />
      </v-card>
    </div>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2" />
      <v-card-actions class="pb-0">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    props: {
      cardDashboard: {
        type: Boolean,
        default: false,
      },
      avatar: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'success',
      },
      icon: {
        type: String,
        default: undefined,
      },
      image: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      background: {
        type: String,
        default: '#FFF',
      },
    },

    computed: {
      classes () {
        return {
          'v-card--material': true,
          'v-card--material--has-heading': this.hasHeading,
          'ma-0': this.cardDashboard,
          'pa-3': true,
        }
      },
      hasHeading () {
        return Boolean(this.$slots.heading || this.title || this.icon)
      },
      hasAltHeading () {
        return Boolean(this.$slots.heading || (this.title && this.icon))
      },
    },
  }
</script>

<style lang="sass">
.v-card--material
  &__avatar
    position: relative
    top: -64px
    margin-bottom: -32px

  &__heading
    position: relative
    top: -40px
    transition: .3s ease
    z-index: 1

.icone-center
  display: flex
  justify-content: center
  align-items: center

</style>
